import "~/Styles/vendor/bootstrap.scss";
import "~/Styles/vendor/bootstrap.critical.scss";
import "~/Styles/base/shame.less";
import "~/Styles/base/typography.less";
import "~/Styles/components/button.less";
import "~/Styles/components/table.less";
import "~/Styles/components/copy.less";
import "~/Styles/components/quote.less";
import "~/Styles/components/statistic.less";
import "~/Styles/components/card.less";
import "~/Styles/components/input.less";
import "~/Styles/components/accordion.less";
import "~/Styles/components/filters.less";
// import "~/Styles/components/tags.less";
import "~/Styles/components/searchResult.less";
import "~/Styles/components/breadcrumb.less";
// import "~/Styles/components/carousel.less";
import "fg-loadcss/dist/cssrelpreload";
import "~/Scripts/modules/fontAwesome";
import { dom } from "@fortawesome/fontawesome-svg-core";

/* Enable hot reloading */
if ( module && module.hot ) {
  module.hot.accept();
}

dom.watch();
